import SelectRadioInputSheet from '../../common/sheets/SelectRadioInputSheet';
import { IncomePayCycle } from '../types/Income';
import {
    formatIncomeType,
    getPayCycleDisplayDetails,
} from '../utils/incomeUtils';

interface IncomePayCycleSelectionSheetProps {
    isOpen: boolean;
    onClose: () => void;
    selectedOption: IncomePayCycle;
    onSelectOption: (payCycle: IncomePayCycle | null) => void;
}

const IncomePayCycleSelectionSheet = ({
    isOpen,
    onClose,
    selectedOption,
    onSelectOption,
}: IncomePayCycleSelectionSheetProps) => {
    return (
        <SelectRadioInputSheet
            title="Pay cycle"
            options={IncomePayCycle}
            selectedOption={selectedOption}
            onSelectOption={onSelectOption}
            isOpen={isOpen}
            onClose={onClose}
            toLabelFn={formatIncomeType}
            toDetailsFn={getPayCycleDisplayDetails}
        />
    );
};

export default IncomePayCycleSelectionSheet;
